import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import { ThemeContext } from 'Contexts'

export const Theme = () => {
  const { theme } = useContext(ThemeContext)

  return ReactDOM.createPortal(<style>{theme}</style>, document.head)
}
